module.exports = __webpack_public_path__ + "static/kv-sp-1f0f564f779523bf6133549c0637d06d.png";